import { PageNotFound, getNotFoundProps } from "@/lib/notFound";
export const getStaticProps = async (context) => getNotFoundProps(context);
export default PageNotFound;
